<template>
  <v-app-bar elevation="0" class="app-header-bar">
    <svg-icon
      :src="projectLogo"
      :width="logoSize.width"
      :height="logoSize.height"
    />
    <v-spacer />
    <template #append>
      <v-app-bar-nav-icon :ripple="false" color="transparent">
        <google-icon
          variant="rounded"
          :fill="false"
          icon="menu"
          color="#60758D"
          :size="iconSize"
          @click="$emit('show')"
        ></google-icon>
      </v-app-bar-nav-icon>
    </template>
  </v-app-bar>
</template>
<script>
export default {
  name: "MobileAppBar",
  data: () => ({}),
  methods: {},
  computed: {
    logoSize() {
      switch (true) {
        case this.$store.getters.isMobilePortrait:
          return { width: "15vh", height: "8vh" };
        case this.$store.getters.isMobileLandscape:
          return { width: "15vw", height: "8vw" };
        default:
          return { width: "10vh", height: "7vh" };
      }
    },
    iconSize() {
      switch (true) {
        case this.$store.getters.isMobilePortrait:
          return "4vh";
        case this.$store.getters.isMobileLandscape:
          return "4vw";
        default:
          return "4vh";
      }
    },
    isFTX4() {
      return this.$store.getters.isFTX4;
    },
    projectLogo() {
      if (this.isFTX4) {
        return require("@/assets/icons/farmacias_tx4.svg");
      } else {
        return require("@/assets/icons/farmacias_tx4_logo.svg");
      }
    }
  }
};
</script>
<style src="@/styles/global.css"></style>
